module.exports = __webpack_public_path__ + "static/media/OstomyAppTerms.c020f696.txt";